module.exports = __webpack_public_path__ + "static/media/google-black-founders-fund.d3ad596d.png";